<template>

    <q-input
        class="mw-form-v2-input"
        :filled="settings.theme.input.filled"
        :outlined="settings.theme.input.outlined"
        :standout="settings.theme.input.standout"
        :borderless="settings.theme.input.borderless"
        :rounded="settings.theme.input.rounded"
        :square="settings.theme.input.square"
        :dense="settings.theme.input.dense"
        v-model="fieldValue"
        :label="field.layout_injected_label ? field.layout_injected_label : field.label"
        mask="###-##-####"
        fill-mask="#"
        unmasked-value

        :rules="field.required  ? [

            val => !!val || requiredText,
            val => val.length > 8 || 'Please use 9 digits'
            ] : []">
      <template v-slot:append>
        <q-icon name="s_badge" />
      </template>
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-input>

</template>

<script>
import OptionalLabel from "@/components/OptionalLabel";
import {mapFields} from "vuex-map-fields";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {

    };
  },
  components: {OptionalLabel},
  emits: ['update:modelValue'],
  methods: {
    isValidUsZipcode() {
      return true;
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please type SSN';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
